import { z } from 'zod';

export const deliveryTypeSchema = z.object({
  id: z.string(),
  code: z.string().optional(),
  name: z.string().optional(),
  eType: z.number(),
  isFromManager: z.boolean(),
  isActive: z.boolean(),
});
export const getDeliveryTypesSchema = z.array(deliveryTypeSchema);
export type GetDeliveryTypesResponse = z.infer<typeof getDeliveryTypesSchema>;
